import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

/**
 * Cuando se cambia de URL en el navbar, el scroll vuelve a la parte superior de la página.
 * @param {object} history de react-router-dom, para poder acceder a la url actual y children de react-router-dom para poder acceder al componente hijo.
 */
function ScrollToTop({ history, children }) {

  // URLS QUE NO NECESITAN SCROLL AUTOMATICO, YA QUE PUEDEN MANEJAR SU PROPIO SCROLL Y ESTE COMPONENTE PUEDE CAUSAR PROBLEMAS.
  const PROTECTED_URLS = [
    '/curadurias/colecciones',
    '/curadurias/series',
    '/curadurias/paises',
    '/curadurias/editoriales'
  ]
  useEffect(() => {
    const unlisten = history.listen((route) => {
      if(PROTECTED_URLS.includes(route.pathname)) return;
      window.scrollTo({top:0, left:0, behavior:'instant'})
    });
    return () => {
      unlisten();
    }
  }, []);

  return <>{children}</>;
}

export default withRouter(ScrollToTop);